class MonthNavigatorController {

    constructor(CommonRequest) {
        'ngInject';

        this.CommonRequest = CommonRequest;

        this.months = [{ id: 13, name: 'None Set'}, ...this.CommonRequest.getMonthList()];

        const finalYear = new Date().getFullYear() + this.finalYearOffset;
        this.years = [{ name: 'None Set'}, ...this.CommonRequest.getYearList(this.firstYear, finalYear).reverse()];
    }

    $onInit() {
        const currentDate = new Date();
        const currentMonthId = this.initialMonth ? this.initialMonth - 1 : currentDate.getMonth();
        const currentYearId = this.initialYear || currentDate.getFullYear();

        this.selectedMonth = this.getCurrentMonth(this.months, currentMonthId);
        this.selectedYear = this.getCurrentYear(this.years, currentYearId);
    }

    getCurrentMonth(months, currentMonthId) {
        return months.filter((m) => (m.id - 1) === currentMonthId).pop();
    }

    getCurrentYear(years, currentYear) {
        return years.filter((y) => y.name === currentYear).pop();
    }

    setMonth(month) {
        this.selectedMonth = month;
        this.onDateChange({month: this.selectedMonth.id, year: this.selectedYear.name});
    }

    setYear(year) {
        this.selectedYear = year;
        this.onDateChange({month: this.selectedMonth.id, year: this.selectedYear.name});
    }

}

export default MonthNavigatorController;


// WEBPACK FOOTER //
// ./app/common/month-navigator/month-navigator-controller.js